
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{staticStyle:{"fill":"none","stroke-width":"0px"},attrs:{"width":"64","height":"64"}}),_c('path',{staticStyle:{"fill":"#363636","stroke-width":"0px"},attrs:{"d":"m47.19,3.09c7.61,0,13.81,4.85,13.81,10.82v36.36c0,3.06-1.58,5.3-2.92,6.64-2.65,2.66-6.62,4.18-10.89,4.18h-29.53c-8.08,0-14.66-5.17-14.66-11.52V13.93c0-5.98,6.2-10.84,13.83-10.84h30.36Zm0-3h-30.36C7.54.09,0,6.29,0,13.93v35.64c0,8.02,7.9,14.52,17.66,14.52h29.53c9.29,0,16.83-6.18,16.81-13.82V13.91C64,6.27,56.48.09,47.19.09Zm-1.26,45.85c-.35-.56-1.12-.67-1.63-.24l-.21.18-13.62-15.63,2.7-2.36c.84-.74.93-2.02.19-2.86l-.48-.55c-.74-.84-2.02-.93-2.86-.19l-.41.36-10.91-12.49c-1.52-1.74-4.17-1.92-5.91-.4l-1.13.99c-1.74,1.52-1.92,4.17-.4,5.91l10.91,12.49-.44.38c-.84.74-.93,2.02-.19,2.86l.48.55c.74.84,2.02.93,2.86.19l2.72-2.38,13.66,15.6-.2.18c-.5.44-.49,1.22,0,1.64l6.71,5.65,2.83-2.47-4.69-7.41h.01Zm-21.36-19.57c-.29.26-.66.38-1.02.38-.43,0-.86-.18-1.17-.53l-8.21-9.4c-.56-.64-.5-1.62.15-2.19.65-.56,1.62-.5,2.19.15l8.21,9.4c.56.64.5,1.62-.15,2.19Z"}}),_c('path',{staticStyle:{"fill":"#d20311","stroke-width":"0px"},attrs:{"d":"m13.97,52.95c-.78,0-1.56-.3-2.15-.91-1.15-1.19-1.13-3.09.06-4.24L47.86,12.82c1.19-1.15,3.09-1.13,4.24.06,1.15,1.19,1.13,3.09-.06,4.24L16.06,52.1c-.58.57-1.34.85-2.09.85Z"}})])
          )
        }
      }
    